<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<app-nav-bar></app-nav-bar>

<div class="container">
  <div class="container-order">
    <header class="header">
      <h1 class="title">{{'ORDER' | translate}} <span>{{ saleInfo.saleShortCode }}</span></h1>
      <app-back-arrow [route]="'/orders'"></app-back-arrow>
    </header>
    <div class="loading" *ngIf="loading">
      <div class="spinner-border" role="status"></div>
    </div>
    <section *ngIf="!loading" class="form-card-group row d-flex justify-content-around" aria-label="Resumen de la orden">
      <section class="form-card info sale-summary col-lg-7" aria-labelledby="sale-information-title">
        <h2 id="sale-information-title" class="summary-card-title">{{ 'SALE_INFORMATION' | translate }}</h2>
        <dl class="summary-list">
          <div class="summary-row">
            <dt>{{ 'ORDER_NUMBER' | translate }}</dt>
            <dd class="order-code">{{ saleInfo.saleShortCode }}</dd>
          </div>
          <div class="summary-row">
            <dt>{{ 'PAYMENT_TYPE' | translate }}</dt>
            <dd>{{ saleInfo.paymentTypeName }}</dd>
          </div>
          <div class="summary-row" *ngIf="saleInfo.giftCardDiscount > 0">
            <dt>{{ 'GIFT_CARD_PAYMENT' | translate }}</dt>
            <dd>{{ appComponent.formatMoney(saleInfo.giftCardDiscount) }}</dd>
          </div>
          <div class="summary-row" *ngFor="let giftCard of giftCardPurchase">
            <dt>{{ 'CARD_AVAILABLE_BALANCE' | translate }}</dt>
            <dd>{{ appComponent.formatMoney(giftCard.balance) }}</dd>
          </div>
          <div class="summary-row" *ngFor="let giftCard of giftCardPurchase">
            <dt>{{ 'CARD_CODE' | translate }}</dt>
            <dd>{{ giftCard.code }}</dd>
          </div>
          <div class="summary-row total-row">
            <dt>{{ 'AMOUNT' | translate }} Total</dt>
            <dd>{{ appComponent.formatMoney(saleInfo.saleEndPrice) }}</dd>
          </div>
          <div class="summary-row">
            <dt>Fecha</dt>
            <dd>
              <ng-container *ngIf="giftCards.length === 1 && items.length === 0">{{ formatDate(saleInfo.saleDate) }}</ng-container>
              <ng-container *ngIf="!(giftCards.length === 1 && items.length === 0)">{{ saleInfo.saleDate }}</ng-container>
            </dd>
          </div>
          <div class="summary-row">
            <dt>{{ 'SHOP_POINTS' | translate }}</dt>
            <dd>{{ saleInfo.shopPointName }}</dd>
          </div>
          <div class="summary-row">
            <dt>{{ 'DELIVERY' | translate }}</dt>
            <dd>{{ saleInfo.expressShipping == 0 ? 'Retirar en tienda' : 'Envío a domicilio' }}</dd>
          </div>
          <div class="summary-row" *ngIf="saleInfo.paymentTypeCode === 'SINPE' || saleInfo.paymentTypeCode === 'BankTransfer' || saleInfo.paymentTypeCode === 'linkpago'">
            <dt>{{ 'RECEIPT' | translate }}</dt>
            <dd><button type="button" class="btn btn-link voucher-button" data-bs-toggle="modal" data-bs-target="#voucherModal">{{ 'SEE' | translate }} <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i></button></dd>
          </div>
        </dl>

        <section class="state-control" aria-labelledby="sale-state-title">
          <div class="state-heading">
            <h3 id="sale-state-title">{{ 'STATUS' | translate }}</h3>
            <span class="state-badge">{{ saleStateName[initialSaleState] }}</span>
          </div>
          <label for="shippingType" class="form-label">Cambiar estado</label>
          <select class="form-select" id="shippingType" [ngModel]="currentSaleState" (change)="saleStateChange($event)" [disabled]="loadingSaleStateChange" aria-describedby="sale-state-help">
            <option *ngFor="let saleStateId of getObjectKeys(saleStateName)" [value]="saleStateId">{{ saleStateName[saleStateId] }}</option>
          </select>
          <small id="sale-state-help" class="form-text">Estado actual: {{ saleStateName[initialSaleState] }}</small>

          <div *ngIf="saleStateChanged" class="pending-state" aria-live="polite">
            <div>
              <strong>Cambio de estado pendiente</strong>
              <span>Nuevo estado: {{ saleStateName[currentSaleState] }}</span>
            </div>
            <div class="state-actions">
              <button type="button" class="btn save-state-button" (click)="changeSaleState()" [disabled]="loadingSaleStateChange"><i class="bi bi-check2-circle" aria-hidden="true"></i> Guardar cambio</button>
              <button type="button" class="btn btn-outline-secondary" (click)="cancelSaleStateChange()" [disabled]="loadingSaleStateChange"><i class="bi bi-x-circle" aria-hidden="true"></i> Cancelar</button>
            </div>
          </div>
          <div class="saving-state" *ngIf="loadingSaleStateChange" role="status" aria-live="polite"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> Guardando estado…</div>
          <div *ngIf="saleStateChangeSuccess" class="alert alert-success state-feedback" role="status">El estado de la orden se guardó correctamente.</div>
          <div *ngIf="saleStateChangeError" class="alert alert-danger state-feedback" role="alert">No se pudo guardar el cambio. Verifica la conexión e inténtalo de nuevo.</div>
        </section>
      </section>

      <section class="form-card info client-summary col-lg-4" gap="3" aria-labelledby="customer-information-title">
        <h2 id="customer-information-title" class="summary-card-title">{{ 'CUSTOMER_INFORMATION' | translate }}</h2>
        <dl class="summary-list">
          <div class="summary-row"><dt>{{ 'NAME' | translate }}</dt><dd>{{ saleInfo.clientName }}</dd></div>
          <div class="summary-row"><dt>{{ 'IDENTIFICATION' | translate }}</dt><dd>{{ saleInfo.clientId }}</dd></div>
          <div class="summary-row"><dt>{{ 'EMAIL' | translate }}</dt><dd>{{ saleInfo.clientEmail }}</dd></div>
          <div class="summary-row"><dt>{{ 'PHONE' | translate }}</dt><dd>{{ saleInfo.clientPhone }}</dd></div>
          <div class="summary-row" *ngIf="saleInfo.expressShipping != 0"><dt>{{ 'ADDRESS' | translate }}</dt><dd>{{ saleInfo.exactDirection }}</dd></div>
          <div class="summary-row" *ngIf="saleInfo.expressShipping === 1"><dt>Waze</dt><dd class="wazeLink"><a [href]="saleInfo.wazeLink" target="_blank" rel="noopener">Waze</a><button type="button" (click)="copyWazeLink()" aria-label="Copiar enlace de Waze"><i class="feather" data-feather="copy" aria-hidden="true"></i></button></dd></div>
          <div class="summary-row" *ngIf="saleInfo.expressShipping != 0"><dt>{{ 'NOTES' | translate }}</dt><dd>{{ saleInfo.notes }}</dd></div>
        </dl>
      </section>
    </section>
    <div *ngIf="(!giftCards || giftCards.length === 0) && items && items.length > 0 && !loading"  class="form-card">
      <h3 class="subtitle">{{'ITEMS' | translate}}</h3>
      <div class="row d-flex">
        <div class="col-md-12">
          <div class="order-item row" *ngFor="let item of items">
            <div class="item-image col-md-3">
              <img *ngIf="item.imageURL" [src]="item.imageURL">
              <img *ngIf="!item.imageURL" src="/assets/static/missing-image.png">
            </div>
            <div class="item-info col-md-9 row">
              <div class="item-title col-md-12">
                <span>{{ item.productName }}</span>
              </div>
              <div class="col-md-12 item-variant">
                <span *ngFor="let variant of item.variants">
                  {{ variant.variantTypeName }} {{ variant.variantValueName }}
                </span>
              </div>
              <div class="col-md-12 item-code">
                <span class="info-title">{{ 'CODE' | translate }}: </span>
                <span>{{ item.itemCode }}</span>
              </div>
              <div class="col-md-12">
                <span class="info-title">{{ 'POINT_OF_SALE' | translate }}: </span>
                <span>{{ item.shopPointName }}</span>
              </div>
              <div class="col-md-6">
                <span class="info-title">{{ 'QUANTITY' | translate }}: </span>
                <span>{{ item.saleItemQuantity }}</span>
              </div>
              <div class="col-md-6 item-price">
                <span>{{ 'PRICE' | translate }}: {{ appComponent.formatMoney(item.saleItemUnitCost) }}</span>
              </div>
              <div class="col-md-12" *ngIf="item.productType == 3">
                <!--ItemBeneficiaries -->
                <button class="beneficiaries-btn mt-2" (click)="showItemBeneficiaries(item.itemId)">
                  {{ 'MANAGE_BENEFICIARIES' | translate }}
                </button>
                <app-item-beneficiaries
                  *ngIf="showItemBeneficiariesComponent && selectedItemId === item.itemId"
                  [clientId]="saleInfo.clientId"
                  [saleId]="saleId"
                  [itemId]="selectedItemId"
                  [clientName]="saleInfo.clientName">
                </app-item-beneficiaries>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
      <table class="items-container table table-bordered" hidden>
        <thead>
          <th scope="col" class="table-start">{{'ITEM' | translate}}</th>
          <th scope="col">{{'PRICE' | translate}}</th>
          <th scope="col">{{'QUANTITY' | translate}}</th>
          <th scope="col">{{'CODE' | translate}}</th>
          <th scope="col">{{'VARIANTS' | translate}}</th>
          <th scope="col">{{'SHOP_POINTS' | translate}}</th>
          <th scope="col" class="table-end">{{'IMAGE' | translate}}</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td>{{ item.productName }}</td>
            <td>{{ appComponent.formatMoney(item.saleItemUnitCost) }}</td>
            <td>{{ item.saleItemQuantity }}</td>
            <td>{{ item.itemCode }}</td>
            <td>
              <table>
                <tr *ngFor="let variant of item.variants">
                  <td>{{ variant.variantTypeName }}</td>
                  <td>{{ variant.variantValueName }}</td>
                </tr>
                <tr *ngIf="!item.variants">
                  <td>{{ 'WITHOUT_VARIANTS' | translate }}</td>
                </tr>
              </table>
            </td>
            <td>{{ item.shopPointName }}</td>
            <td>
              <img *ngIf="item.imageURL" [src]="appComponent.randomCacheID(item.imageURL)" />
              <span *ngIf="!item.imageURL">{{'NO_IMAGE' | translate}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="loading" *ngIf="loading">
          <div class="spinner-border" role="status"></div>
      </div>
    </div>

  <div *ngIf="!loading && giftCards && giftCards.length > 0 && (!items || items.length === 0)"  class="form-card">
      <h5 class="subtitle">{{'GIFT_CARDS' | translate}}</h5>
      <table class="items-container table table-bordered">
          <thead>
              <th scope="col" class="table-start">{{'NAME' | translate}}</th>
              <th scope="col">{{'PRICE' | translate}}</th>
              <th scope="col">{{'QUANTITY' | translate}}</th>
          <th scope="col">{{'CODE' | translate}}</th>
              <th scope="col">{{'STATUS' | translate}}</th>
              <th scope="col" class="table-end">{{'IMAGE' | translate}}</th>
          </thead>
          <tbody>
              <tr *ngFor="let giftCard of giftCards">
                  <td>{{ giftCard.name }}</td>
                  <td>{{ appComponent.formatMoney(giftCard.saleGiftCardUnitCost)}}</td>
                  <td>{{ giftCard.saleGiftCardQuantity }}</td>
                  <td>{{ giftCard.code }}</td>
                  <td>{{ giftCard.status === 0 ? ('INACTIVE' | translate) : (giftCard.status === 1 ? ('ACTIVE' | translate) : ('PENDING' | translate)) }}</td>
                  <td>
                      <img *ngIf="giftCard.images" [src]="appComponent.randomCacheID(giftCard.images)" />
                      <span *ngIf="!giftCard.images">{{'NO_IMAGE' | translate}}</span>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>

  <div *ngIf="giftCards && giftCards.length > 0 && items && items.length > 0" class="form-card">
      <h5 class="subtitle">{{'GIFT_CARDS' | translate}}</h5>
      <table class="items-container table table-bordered">
          <thead>
              <th scope="col" class="table-start">{{'NAME' | translate}}</th>
              <th scope="col">{{'PRICE' | translate}}</th>
              <th scope="col">{{'QUANTITY' | translate}}</th>
              <th scope="col">{{'CODE' | translate}}</th>
              <th scope="col">{{'STATUS' | translate}}</th>
              <th scope="col" class="table-end">{{'IMAGE' | translate}}</th>
          </thead>
          <tbody>
              <tr *ngFor="let giftCard of giftCards">
                  <td>{{ giftCard.name }}</td>
                  <td>{{ appComponent.formatMoney(giftCard.saleGiftCardUnitCost)}}</td>
                  <td>{{ giftCard.saleGiftCardQuantity }}</td>
                  <td>{{ giftCard.code }}</td>
                  <td> {{ giftCard.status === 0 ? ('INACTIVE' | translate) : (giftCard.status === 1 ? ('ACTIVE' | translate) : ('PENDING' | translate)) }}</td>
                  <td>
                      <img *ngIf="giftCard.images" [src]="appComponent.randomCacheID(giftCard.images)" />
                      <span *ngIf="!giftCard.images">{{'NO_IMAGE' | translate}}</span>
                  </td>
              </tr>
          </tbody>
      </table>

      <h3 class="subtitle">{{ 'ITEMS' | translate }}</h3>
      <table class="items-container table table-bordered">
          <thead>
              <th scope="col" class="table-start">{{ 'ITEM' | translate }}</th>
              <th scope="col">{{'PRICE' | translate}}</th>
              <th scope="col">{{'QUANTITY' | translate}}</th>
              <th scope="col">{{'CODE' | translate}}</th>
              <th scope="col">{{'VARIANTS' | translate}}</th>
              <th scope="col">{{'SHOP_POINTS' | translate}}</th>
              <th scope="col" class="table-end">{{'IMAGE' | translate}}</th>
          </thead>
          <tbody>
              <tr *ngFor="let item of items">
                  <td>{{ item.productName }}</td>
                  <td>{{ appComponent.formatMoney(item.saleItemUnitCost) }}</td>
                  <td>{{ item.saleItemQuantity }}</td>
                  <td>{{ item.itemCode }}</td>
                  <td>
                      <table>
                          <tr *ngFor="let variant of item.variants">
                              <td>{{ variant.variantTypeName }}</td>
                              <td>{{ variant.variantValueName }}</td>
                          </tr>
                          <tr *ngIf="!item.variants">
                              <td>{{ 'WITHOUT_VARIANTS' | translate }}</td>
                          </tr>
                      </table>
                  </td>
                  <td>{{ item.shopPointName }}</td>
                  <td>
                      <img *ngIf="item.imageURL" [src]="appComponent.randomCacheID(item.imageURL)" />
                      <span *ngIf="!item.imageURL">{{'NO_IMAGE' | translate}}</span>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>

  <div *ngIf="!loading" class="form-card">
    <h3 class="subtitle">{{ 'PAYMENTS' | translate }}</h3>
    <table class="items-container table table-bordered">
        <thead>
            <th scope="col" class="table-start">ID</th>
            <th scope="col">{{'AMOUNT' | translate}}</th>
            <th scope="col">{{ 'PAYMENT_DATE' | translate }}</th>
            <th scope="col" class="table-end">{{'AMOUNT' | translate}} total</th>
        </thead>
        <tbody>
            <tr *ngFor="let payment of salePayment">
              <td>{{ payment.salePaymentId }}</td>
              <td>{{ appComponent.formatMoney(payment.salePaymentAmount) }}</td>
              <td>{{ formatDate(payment.salePaymentDate) }}</td>
              <td>{{ appComponent.formatMoney(payment.saleTotalAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>

  <div *ngIf="!loading && saleLog" class="form-card">
    <h3 class="subtitle">{{ 'SALE_LOGS' | translate }}</h3>
    <!-- Response Payload -->
    <div class="col-lg-12">
      <div class="card h-100 border-success-subtle">
        <div class="card-header bg-success-subtle d-flex justify-content-between align-items-center py-2">
          <small class="fw-semibold text-success-emphasis">
            <i class="bi bi-arrow-left-circle me-1"></i>{{ 'RESPONSE_DATA' | translate }}
          </small>
        </div>
        <div class="card-body p-0">
          <pre class="m-0 p-3 bg-dark text-light rounded-bottom" 
                style="max-height: 250px; overflow-y: auto; font-size: 0.75rem;">
            <code>{{ saleLog.responsePayload | json }}</code>
          </pre>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" tabindex="-1" id="voucherModal" *ngIf="saleInfo.paymentTypeCode != 'CreditCard'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <h5 class="modal-title">Modal title</h5> -->
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img [src]="saleInfo.saleVoucher" />
        </div>
        <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
